/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vamos a crear un pequeño formulario con un input de texto y un botón que nos ayudará a buscar pokémones.`}</p>
    <p>{`La PokéApi te permite buscar pokémones por su nombre en minúsculas y por ID, así que vamos a manejar ambos casos.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//Ambas son válidas`}</span>{`
`}<span parentName="code" {...{
            "className": "token string"
          }}>{`'pokeapi.co/api/v2/pokemon/25'`}</span>{`

`}<span parentName="code" {...{
            "className": "token string"
          }}>{`'pokeapi.co/api/v2/pokemon/pikachu'`}</span>{`
`}</code></pre></div>
    <p>{`En algún momento tendremos que validar si el usuario ingreso un número o un nombre y en caso de que haya sido un nombre, debemos de ponerlo en minúsculas, ya que el autócorrector puede hacer que escribamos "Pikachu".`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;